import actions from '../../actionTypes';

export default (area, site) => {
  return {
    type: actions.EDIT_AREA,
    area,
    site
  };
};



// WEBPACK FOOTER //
// ./src/reducers/areas/actions/editArea.js